exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, ".active a[data-v-12aff986]:after{transform:rotate(180deg)}a[data-v-12aff986]{font-size:16px;font-family:Arial,sans-serif}a[data-v-12aff986]:after{content:\"\\25BC\";display:inline-block;margin-left:5px;transform:rotate(0deg);transition:.3s}@media (max-width:1023px){div[data-v-12aff986]{padding:20px;border-bottom:1px solid}a[data-v-12aff986]:after{transform:rotate(-90deg)}}@media (min-width:1024px){div[data-v-12aff986]{border:1px solid;padding:7px 10px}a[data-v-12aff986]{display:block;position:relative}a[data-v-12aff986]:after{position:absolute;right:0;top:0}a span[data-v-12aff986]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-12aff986","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/ToggleFilter.vue
// module id = 469
// module chunks = 0